import { render, staticRenderFns } from "./MarketingPopup.vue?vue&type=template&id=4d3263e9&scoped=true&"
import script from "./MarketingPopup.vue?vue&type=script&lang=js&"
export * from "./MarketingPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarketingPopup.vue?vue&type=style&index=0&id=4d3263e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3263e9",
  null
  
)

export default component.exports